"use client";

import { CompositeContextProvider, CompositeScopedContextProvider } from "./P7GR5CS5.js";
import { PopoverContextProvider, PopoverScopedContextProvider } from "./MTZPJQMC.js";
import { createStoreContext } from "./LMDWO4NN.js"; // src/select/select-context.tsx

import { createContext } from "react";
var ctx = createStoreContext([PopoverContextProvider, CompositeContextProvider], [PopoverScopedContextProvider, CompositeScopedContextProvider]);
var useSelectContext = ctx.useContext;
var useSelectScopedContext = ctx.useScopedContext;
var useSelectProviderContext = ctx.useProviderContext;
var SelectContextProvider = ctx.ContextProvider;
var SelectScopedContextProvider = ctx.ScopedContextProvider;
var SelectItemCheckedContext = createContext(false);
var SelectHeadingContext = createContext(null);
export { useSelectContext, useSelectScopedContext, useSelectProviderContext, SelectContextProvider, SelectScopedContextProvider, SelectItemCheckedContext, SelectHeadingContext };